module.exports = __webpack_public_path__ + "static/media/CNAMEmockup.56cb55f2.png";